import { clientGuidServiceFactory } from '@zeus/react-common/lib/business/service/client-guid-service'
import { tokenService } from '@zeus/react-common/lib/business/service/token-service'
import { browserUtil } from '@zeus/react-common/lib/util/browser-util'
import { authRepo } from 'src/business/repo/auth-repo'

export class AuthService {
  async login(params: { email: string; password: string; invitationCode: string | null }): Promise<void> {
    const { email, password, invitationCode } = params
    const clientGuid = await clientGuidServiceFactory().getOrCreate()
    const { accessToken, refreshToken, redirectUrl } = await authRepo().Public.login({ clientGuid, email, password, isWebClient: true })
    await tokenService.store({ accessToken, refreshToken })
    if (invitationCode) {
      await this.invitationCodeFulfill(invitationCode)
    }
    if (redirectUrl) browserUtil.redirect(redirectUrl)
  }

  async resetPassword(params: { email: string }): Promise<void> {
    const { email } = params
    if (!email) throw Error('Email is required')
    const clientGuid = await clientGuidServiceFactory().getOrCreate()
    await authRepo().Public.requestResetPassword({ email, clientGuid })
  }
  async resetPasswordFulfill(params: { password: string; code: string }): Promise<void> {
    const { password, code } = params
    if (!password || !code) throw Error('Missing parameters')
    const clientGuid = await clientGuidServiceFactory().getOrCreate()
    await authRepo().Public.requestResetPasswordFulfill({ password, code, clientGuid })
  }
  async verifyEmail(params: { code: string }): Promise<void> {
    const { code } = params
    if (!code) throw Error('Code is mandatory')
    await authRepo().Public.verifyEmail({ code })
  }

  async verifyEmailResend(): Promise<void> {
    const clientGuid = await clientGuidServiceFactory().getOrCreate()
    await authRepo().Authorised.verifyResend({ clientGuid })
  }
  async emailExist(params: { email: string }): Promise<{ emailExist: boolean } | undefined> {
    const { email } = params
    const result = (await authRepo().Public.emailExist({ email })).data
    return result[0]
  }

  async validateStrongPassword(params: { password: string }): Promise<{
    score: number
    feedback: {
      warning: string
      suggestions: string[]
    }
  }> {
    const { password } = params
    const result = (await authRepo().Public.verifyStrongPassword({ password })).data
    return result[0]
  }

  async invitationCodeFulfill(code: string): Promise<void> {
    await authRepo().Authorised.fulfillInvitation(code)
  }

  async getMetaFromInvitationCode(params: { invitationCode: string }): Promise<{ email: string } | undefined> {
    const { invitationCode } = params
    return (await authRepo().Public.getMetaFromTempCode({ invitationCode })).data[0]
  }
}

export const authServiceFactory = (): AuthService => new AuthService()
